import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-time-customers',
  templateUrl: './time-customers.component.html',
  styleUrls: ['./time-customers.component.css']
})
export class TimeCustomersComponent implements OnInit {
    public setting?: Setting;

    public itemsListTimeCustomers: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1290))[0];
    }

    private async loadTimeCustomers() {
        this.itemsListTimeCustomers = await this.datatask.Post(52, {
            cust_name: 'ALL',
            project_keyno: '0',
            ok: '0'
        });
    }

    private async init() {
        this.loadSetting();
        this.loadTimeCustomers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
